/* eslint-disable react-hooks/rules-of-hooks */
import { Address } from 'features/organizations/sites/models/sites-models';
import EmptyImage from '../imgs/emptyImage.jpg';
import { getAccessToken } from 'auth/get-access-token';

const apiURI= process.env.REACT_APP_API_URL;

export enum RequestDataType {
    FormData,
    Entity
}

function createFormData<T extends object>(data: T): FormData {
    const formDataToSend = new FormData();
    Object.entries(data).forEach(([key, value]) => {
        if (value) {
            if (key === 'address' && typeof value === 'object') {
                const addressObj = value as Address;
                Object.entries(addressObj).forEach(([addressKey, addressValue]) => {
                    formDataToSend.append(`address.${addressKey}`, addressValue);
                });
            } else {
                formDataToSend.append(key, value);
            }
        }
    });
    //// Just for debugging
    //for (const [key, value] of formDataToSend.entries()) {
    //    console.log(key, value);
    //}

    return formDataToSend;
}

export const getRequest = async (routingPath: string): Promise<any> => {
    try {
        const accessToken = await getAccessToken();
        const response = await fetch(`${apiURI}${routingPath}`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
        var result = await response.json();
        return result;
    } catch (e) {
        console.error(e);
    }
};


export const getImageRequest = async (routingPath: string): Promise<any> => {
    try {
        const accessToken = await getAccessToken();
        const response = await fetch(`${apiURI}${routingPath}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        if (response.status === 404) {
            return EmptyImage;
        }
        if (!response.ok && response.status !== 404) {
            throw new Error('Failed to fetch image');
        }
        const result = await response.blob();
        return URL.createObjectURL(result);
    } catch (error) {
        console.error('Error fetching the image:', error);
        return EmptyImage;
    }
};

export const getFileRequest = async (routingPath: string): Promise<string> => {
    try {
        const accessToken = await getAccessToken();
        const response = await fetch(`${apiURI}${routingPath}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        if (response.status === 404) {
            console.error('File not found');
            return "";
        }
        if (!response.ok) {
            throw new Error('Failed to fetch the file');
        }
        const result = await response.blob();

        return URL.createObjectURL(result);

    } catch (error) {
        console.error('Error fetching the 3D file:', error);
        return "";
    }
};

export const postRequest = async (routingPath: string, data: any, requestDataType: RequestDataType): Promise<{ result: any, statusCode: number }> => {
    try {
        const accessToken = await getAccessToken();
        const dataBody = (requestDataType == RequestDataType.Entity) ? JSON.stringify(data) : createFormData(data);    
        const headers: { [key: string]: string } = {
            Authorization: `Bearer ${accessToken}`,
        };

        if (requestDataType === RequestDataType.Entity) {
            headers['Content-Type'] = 'application/json';
        }
        const response = await fetch(`${apiURI}${routingPath}`, {
            method: 'POST',
            headers,
            body: dataBody,
        });

        const result = await response.json();

        if (response.ok) {
            return {
                result,
                statusCode: response.status,
            };
        } else {
            console.warn(response);
            console.warn("POST request failed");
            return {
                result: "",
                statusCode: response.status,
            };
        }
    } catch (error) {
        console.error(error);
        return {
            result: "",
            statusCode: 400,
        };
    }
};

export const putRequest = async (routingPath: string, data: any, requestDataType: RequestDataType): Promise<{ statusCode: number }> => {
    try {
        const accessToken = await getAccessToken();
        const dataBody = (requestDataType == RequestDataType.Entity) ? JSON.stringify(data) : createFormData(data);
        const headers: { [key: string]: string } = {
            Authorization: `Bearer ${accessToken}`,
        };

        if (requestDataType === RequestDataType.Entity) {
            headers['Content-Type'] = 'application/json';
        }
        const response = await fetch(`${apiURI}${routingPath}`, {
            method: 'PUT',
            headers,
            body: dataBody,
        });
        if (response.ok) {
            return {
                statusCode: response.status,
            };
        } else {
            console.warn("PUT request failed");
            return {
                statusCode: response.status,
            };
        }
    } catch (error) {
        console.error(error);
        return {
            statusCode: 400,
        };
    }
};

export const deleteRequest = async (routingPath: string, entityId: string): Promise<{ statusCode: number }> => {
    try {
        const accessToken = await getAccessToken();
        const response = await fetch(`${apiURI}${routingPath}/${entityId}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            }
        });
        if (response.ok) {
            return {
                statusCode: response.status,
            };
        } else {
            console.warn("Delete request failed");
            return {
                statusCode: response.status,
            };
        }
    } catch (error) {
        console.error(error);
        return {
            statusCode: 400,
        };
    }
};

export const deleteEntityRequest = async (routingPath: string, data: any): Promise<{ statusCode: number }> => {
    try {
        const accessToken = await getAccessToken();
        const dataBody =JSON.stringify(data) ;

        const response = await fetch(`${apiURI}${routingPath}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            body:dataBody
        });
        if (response.ok) {
            return {
                statusCode: response.status,
            };
        } else {
            console.warn("Delete request failed");
            return {
                statusCode: response.status,
            };
        }
    } catch (error) {
        console.error(error);
        return {
            statusCode: 400,
        };
    }
};

